import { AlignEnum, FlexDirectionsEnum, JustifyEnum } from '../../types';

type FlexDecoratorProps = {
	align?: AlignEnum;
	flex?: FlexDirectionsEnum;
	justify?: JustifyEnum;
};

export const flexDecorator = ({ align, flex, justify }: FlexDecoratorProps) => {
	switch (flex) {
		case FlexDirectionsEnum.column:
		case FlexDirectionsEnum['column-reverse']:
		case FlexDirectionsEnum.row:
		case FlexDirectionsEnum['row-reverse']:
			return `
        ${!!align ? `align-items: ${align}` : ''};
        display: flex;
        flex-direction: ${flex};
        ${!!justify ? `justify-content: ${justify}` : ''};
      `;
		default:
			return '';
	}
};
